export default __webpack_public_path__ + "static/web-resume-cf89ccae0b773c891bd958e66206b7bb.pdf";